module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product15-ef70e09b63a54b0c018c468de87ec8ad.jpg";